import { sqliteTable, text, integer, real } from "drizzle-orm/sqlite-core";

// ============================================================================
// ai_agents — AI Agent definitions (1 agent per row)
// ============================================================================
export const aiAgents = sqliteTable("ai_agents", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  description: text("description"),
  systemPrompt: text("system_prompt").notNull().default(""),
  agentType: text("agent_type").notNull().default("standalone"), // 'standalone' | 'orchestrator'
  aiProvider: text("ai_provider"),
  aiModel: text("ai_model"),
  apiKeySource: text("api_key_source").notNull().default("tenant"), // 'tenant' | 'platform'
  temperature: real("temperature").default(0.7),
  maxSteps: integer("max_steps").default(5),
  isDefault: integer("is_default").default(0), // default agent for new pages
  isActive: integer("is_active").default(1),
  // Audit fields
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type AiAgent = typeof aiAgents.$inferSelect;
export type NewAiAgent = typeof aiAgents.$inferInsert;
